import { render, staticRenderFns } from "./QuestionPhone.vue?vue&type=template&id=d299bc74&scoped=true&"
import script from "./QuestionPhone.vue?vue&type=script&lang=js&"
export * from "./QuestionPhone.vue?vue&type=script&lang=js&"
import style0 from "./QuestionPhone.vue?vue&type=style&index=0&id=d299bc74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d299bc74",
  null
  
)

export default component.exports